/**
 * DimensionFilter Component
 *
 * Multi-select filter for conduct dimensions.
 * Default is OR logic (match ANY), user can toggle to AND (match ALL).
 */

import { Layers } from 'lucide-react';
import { FilterDropdown } from './FilterDropdown';
import type { DimensionFilterProps, ConductDimension } from '../types/filter.types';
import { DIMENSION_OPTIONS, DEFAULT_FILTER_LOGIC } from '../constants/filter.constants';
import { useFilterWithLogic } from '../hooks/useFilterWithLogic';

export function DimensionFilter({
  value,
  onChange,
  disabled = false,
  className,
}: DimensionFilterProps) {
  const { currentLogic, handleValuesChange, handleLogicChange, helperText } =
    useFilterWithLogic<ConductDimension>({
      value,
      onChange,
      defaultLogic: DEFAULT_FILTER_LOGIC.dimensions,
      noun: 'dimensions',
    });

  return (
    <FilterDropdown
      value={value?.values}
      onChange={handleValuesChange}
      options={DIMENSION_OPTIONS}
      icon={<Layers className="h-4 w-4" />}
      emptyLabel="All Dimensions"
      pluralNoun="dimensions"
      helperText={helperText}
      showDescriptions
      disabled={disabled}
      className={className}
      logicMode={currentLogic}
      onLogicModeChange={handleLogicChange}
    />
  );
}
